import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { CerereSabloaneService } from '../cerere-sabloane.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper'
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { SablonAddPayload } from '../sabloane.interface';

@Component({
    selector: 'app-add-cerere-sabloane',
    templateUrl: './add-cerere-sabloane.component.html',
    styleUrls: ['./add-cerere-sabloane.component.scss'],
})
export class AddCerereSabloaneComponent implements OnInit {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    editorConfig!: AngularEditorConfig;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        content: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCerereSabloaneComponent>,
        private cerereSabloaneService: CerereSabloaneService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.cerereSabloaneService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, content } = this.form
            .value as SablonAddPayload;

        const sablon: SablonAddPayload = {
            name,
            content
        };

        this.cerereSabloaneService
            .addSablon(sablon)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: () => {
                    let errorMessage = environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
                },
            });
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
    }
}
